import React from "react"

const Custom03 = () => {
  return <div>Custom03</div>
}

export { Custom03 as default }
